import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import RegReport from "../../CcpSchool/CcpSchoolReports/inc/RegReport";

const DistrictRegReport = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>
        Registration Report
      </ModalDialogTitle>
      <DialogContent>
        <RegReport schoolId={schoolId} />
      </DialogContent>
    </Dialog>
  );
};

export default DistrictRegReport;
